<template>
    <rkm-overlay>
        <rkm-layout-body title="Edição de registro de vacinação">
            <template v-slot:actions>
                <rkm-button
                    @click="handleExit"
                    color="danger"
                >
                    Sair
                </rkm-button>

                <template v-if="additionals && additionals.salaVacinacaoLogada && !!additionals.salaVacinacaoLogada.id">
                    <rkm-button
                        @click="$refs.Form.printRegistroVacinacao()"
                        color="info"
                    >
                        Imprimir
                    </rkm-button>

                    <rkm-button
                        @click="$refs.Form.printCarteiraVacinacao()"
                        color="info"
                    >
                        Imprimir carteirinha de vacinação
                    </rkm-button>

                    <rkm-button
                        @click="$refs.Form.printCertidaoRegularidade()"
                        color="info"
                    >
                        Imprimir certidão de regularidade
                    </rkm-button>

                    <rkm-button
                        @click="$refs.Form.save()"
                        color="primary"
                    >
                        Salvar
                    </rkm-button>
                </template>
            </template>

            <rkm-layout-content>
                <Form
                    :fila-id="filaId"
                    :id="id"
                    @loaded="habdleLoaded"
                    @save="handleSave"
                    ref="Form"
                />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import Form from '@/components/imunizacao/registro-vacinacao/Form'

// Mixins.
import {error, repository} from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    components: { Form },
    created() {
        this.repositories = {
            filaAtendimento: this.getConectaSusRepository('imunizacao.filaAtendimento'),
        }
    },
    data: () => ({
        additionals: null,
    }),
    methods: {
        ...mapActions([
            'setLoading',
            'setShowExitFormConfirmation',
            'unsetLoading',
            'unsetShowExitFormConfirmation',
        ]),
        habdleLoaded(object) {
            this.additionals = object.additionals

            if (this.additionals && this.additionals.salaVacinacaoLogada && !!this.additionals.salaVacinacaoLogada.id) {
                this.setShowExitFormConfirmation()
            }
        },
        redirectToList() {
            this.unsetShowExitFormConfirmation()

            if (this.filaId) {
                this.$router.push('/imunizacao/fila-atendimento/index')
            } else {
                this.$router.push('/imunizacao/registro-vacinacao/index')
            }
        },
        handleSave() {
            this.redirectToList()
        },
        handleExit() {
            this.showExitConfirmation(async () => {
                if (this.filaId) {
                    this.setLoading()

                    return this.repositories.filaAtendimento.sendBack(this.filaId)
                        .then(() => this.redirectToList())
                        .finally(() => this.unsetLoading())
                } else {
                    this.redirectToList()
                }
            }, this.handleError)
        },
    },
    mixins: [error, repository],
    props: {
        id: { type: Number, default: null },
        filaId: { type: Number, default: null },
    },
}
</script>